import { Container, Alert, Typography, Button, Box } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
export function ErrorFallback({
  error,
  resetErrorBoundary,
}: {
  error: Error;
  resetErrorBoundary: () => void;
}) {
  return (
    <>
      <Container>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="100vh"
          flexDirection="column"
        >
          <Alert severity="error">
            <Typography>{error.name}</Typography>
            <Typography>{error.message}</Typography>
            <Typography>{error.stack}</Typography>
          </Alert>
          <Button
            onClick={resetErrorBoundary}
            startIcon={<ArrowBackIosIcon />}
            sx={{ marginLeft: '5' }}
          >
            Back
          </Button>
        </Box>
      </Container>
    </>
  );
}
